<template>
  <schoolRoutesDriversForm :typeEndPoint="'schoolRoutesDriversForm'" :dataParams="{}"/>
</template>
<script>
import schoolRoutesDriversForm from '@/components/modules/schoolroutes/drivers/form'
export default {
  name: 'schoolRoutesDriversFormCreate',
  components: {
    schoolRoutesDriversForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/drivers/create.vue